import { Component, computed, effect, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { ReflectionFacade } from '@app/store/reflection';
import { AssignmentsFacade } from '@app/store/assignments';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule, Tooltip],
})
export class DeleteButtonComponent {
    private readonly reflectionFacade = inject(ReflectionFacade);
    private readonly assignmentsFacade = inject(AssignmentsFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly reflectionId = input.required<string>();
    readonly saving = input<boolean>(false);

    readonly hasAssignments = computed(() => this.assignmentsFacade.assignments(this.reflectionId(), 'reflection')().length > 0);

    constructor() {
        effect(() => {
            this.assignmentsFacade.getAssignments(this.reflectionId(), 'reflection');
        });
    }

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('reflections.delete.header'),
            message: this.translateService.instant('reflections.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('reflections.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('reflections.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.reflectionFacade.deleteReflection(this.reflectionId());
            },
        });
    }
}
